<template>
  <div class="importer-content">
    <loader v-if="loading && !doEsign" :height="500" />
    <ack-list :invoices="ackInvoices" v-if="!loading" />
    <boe-list :invoices="boeInvoices" v-if="!loading" />
    <template
      v-if="ackInvoices.length === 0 && !loading && boeInvoices.length === 0"
    >
      <h1 class="page-title section-title">
        {{ $t('importers.index.noDocs') }}
      </h1>
    </template>
  </div>
</template>
<script>
// loading data in this component to facilitate easy managing of single loader and empty state.
// To be refactored soon.
import Loader from '@/components/common/Loader'
import AckList from '@/components/importers/esignList/Ack'
import BoeList from '@/components/importers/esignList/Boe'
import axios from 'axios'
import importersService from '@/services/importers'

export default {
  data() {
    return {
      ackInvoices: [],
      boeInvoices: [],
      esignUrl: null,
      doEsign: false,
      esignSuccess: false,
      documentUrl: null,
      loading: true
    }
  },
  computed: {
    redirectUrl() {
      return process.env.VUE_APP_DRIP_PORTAL_HOST
    }
  },
  mounted() {
    document.title = 'Importers | Drip Portal'
    this.$mpTrack('Importers page mounted')
    return this.getInvoices()
  },
  methods: {
    getInvoices() {
      return axios.all([this.getAckInvoices(), this.getBoeInvoices()]).then(
        axios.spread((ackInvoices, boeInvoices) => {
          this.loading = false

          this.ackInvoices = ackInvoices.data.invoice_ack_signable_invoices
          ackInvoices.data.invoice_ack_signable_invoices.forEach((element) => {
            element.selected = true
          })

          this.boeInvoices = boeInvoices.data.invoice_boe_signable_invoices
          boeInvoices.data.invoice_boe_signable_invoices.forEach((element) => {
            element.selected = true
          })
        })
      )
    },
    getAckInvoices() {
      return importersService.getAckInvoices(
        this.$store.state.account.accountId,
        {
          include: ['invoice_ack_signable_invoices']
        }
      )
    },
    getBoeInvoices() {
      return importersService.getAckInvoices(
        this.$store.state.account.accountId,
        {
          include: ['invoice_boe_signable_invoices']
        }
      )
    }
  },
  components: {
    Loader,
    AckList,
    BoeList
  }
}
</script>
<style lang="scss" scoped>
.importer-content {
  padding-top: 40px;
}
</style>
